import { ColumnVisibilityItem } from "providers/Auth";

// Appends any column that didn't exist when the stored blob was written.
export const mergeColumnsWithDefaults = (
  savedColumns: ColumnVisibilityItem[] | undefined,
  defaults: ColumnVisibilityItem[]
) => {
  if (!savedColumns) return defaults;

  const savedColumnIds = new Set(savedColumns.map((col) => col.id));
  const mergedColumns = [...savedColumns];

  defaults.forEach((defaultCol) => {
    if (!savedColumnIds.has(defaultCol.id)) mergedColumns.push(defaultCol);
  });

  return mergedColumns;
};
